import { Subject } from "rxjs";

const ExternalDisposeSubject = new Subject();

const ExternalDisposeService = {
  listen: () => ExternalDisposeSubject.asObservable(),
  onDispose: (conversationId) => ExternalDisposeSubject.next(conversationId),
};

export default ExternalDisposeService;
